import { viewEmail, taskEmailLabel } from './LinkedEmailEntity.locstring.json';
import { observer } from 'mobx-react-lite';
import { ActionButton } from '@fluentui/react/lib/Button';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import * as React from 'react';
import { TooltipHost } from '@fluentui/react/lib/Tooltip';

const styles = require('./LinkedEmailEntity.scss');

export interface LinkedEmailEntityProps {
    emailId: string;
    onClick: (emailId: string) => void;
    style: string;
    iconStyle: string;
    showEmailLabel: boolean;
}

export default observer(function LinkedEmailEntity(props: LinkedEmailEntityProps) {
    const { emailId, onClick, style, iconStyle, showEmailLabel } = props;

    const viewEmailCallback = React.useCallback(() => {
        onClick(emailId);
    }, [onClick, emailId]);

    return (
        <TooltipHost content={loc(viewEmail)} hostClassName={styles.toolTipHost}>
            <ActionButton
                className={style}
                onClick={viewEmailCallback}
                ariaLabel={loc(viewEmail)}
                text={showEmailLabel ? loc(taskEmailLabel) : undefined}
                styles={{ textContainer: styles.textDescription }}
                iconProps={{
                    iconName: ControlIcons.Mail,
                    className: iconStyle,
                }}
            />
        </TooltipHost>
    );
});
